import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-primer-separador',
  templateUrl: './primer-separador.component.html',
  styleUrls: ['./primer-separador.component.css']
})
export class PrimerSeparadorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
